function waitForAOS() {
    if (typeof AOS !== "undefined") {
        AOS.init({});
    } else {
        setTimeout(waitForAOS, 100);
    }
}

waitForAOS();

function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

const textAnim = $(".split-anim-title");
if (textAnim) {
    textAnim.each(function () {
        const _this = $(this);
        let html = _this.html().replace(/<br\s*\/?>/gi, ' <br> ');
        html = decodeHTML(html);
        const cleanHtml = html.trim().replace(/\s+/g, ' ');
        const textArr = cleanHtml.split(" ");

        _this.text("");

        let line = 1;
        let lastOffsetTop = null;

        textArr.forEach(function (word, index) {
            if (word === "<br>") {
                const span = document.createElement("span");
                span.classList.add('brl')
                _this.append(span);
                return;
            }

            if (word === "|") {
                const span = document.createElement("span");
                span.classList.add('brl')
                _this.append(span);
                return;
            }

            if (word === "||") {
                const span = document.createElement("span");
                span.classList.add('brl-space')
                _this.append(span);
                return;
            }

            const span = document.createElement("span");
            const span_inner = document.createElement("span");

            $(span).addClass("split-anim");
            $(span_inner).addClass("split-anim__inner");
            span_inner.textContent = word;
            span.append(span_inner);
            _this.append(span);

            const empt = document.createElement("span");
            $(empt).text(" ");
            _this.append(empt);

            const currentOffsetTop = span.offsetTop;

            if (lastOffsetTop === null) {
                lastOffsetTop = currentOffsetTop;
            } else if (currentOffsetTop > lastOffsetTop) {
                line++;
                lastOffsetTop = currentOffsetTop;
            }

            $(span_inner).addClass(`count-${line}`);
        });
    });
}


function observeAndSyncAosAnimate(selector) {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const firstAnimated = [...elements].find(el => el.classList.contains('aos-animate'));

                if (!firstAnimated) {
                    entry.target.classList.add('aos-animate');

                    elements.forEach(el => {
                        if (el !== entry.target) {
                            el.classList.add('aos-animate');
                        }
                    });

                    const text = document.querySelectorAll('.our-case-studies__text');
                    if (text.length) {
                        text.forEach(el => {
                            if (el !== entry.target) {
                                el.classList.add('aos-animate');
                            }
                        });
                    }
                    const title = document.querySelectorAll('.our-case-studies__title-item');
                    if (title.length) {
                        title.forEach(el => {
                            if (el !== entry.target) {
                                el.classList.add('aos-animate');
                            }
                        });
                    }
                }
            }
        });
    }, {
        rootMargin: '100px 0px -100px 0px'
    });

    elements.forEach(el => observer.observe(el));
}
setTimeout(() => {
    observeAndSyncAosAnimate('[data-aos="case-scale"]');
}, 200)


// logo anim in scroll section
const title = document.querySelector('.scroll__bottom ');
const lottieContainer = document.querySelector('.scroll__bottom-svg');
let animationStarted = false;
const lottieDuration = 1800;
if (title && lottieContainer) {
    const jsonPath = lottieContainer.getAttribute('data-src');

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                mutation.type === 'attributes' &&
                title.classList.contains('visible') &&
                !animationStarted
            ) {
                setTimeout(() => {

                    animationStarted = true;

                    const animation = lottie.loadAnimation({
                        container: lottieContainer,
                        renderer: 'svg',
                        loop: false,
                        autoplay: true,
                        path: jsonPath
                    });

                    animation.addEventListener('complete', () => {
                        lottieContainer.classList.add('hidden');
                    });

                    observer.disconnect();
                }, 400)

            }
        });
    });

    observer.observe(title, {
        attributes: true,
        attributeFilter: ['class']
    });
}


